function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.413 5.13a3.613 3.613 0 0 0-.892-1.63 3.527 3.527 0 0 0-1.577-.957C23.755 2 15 2 15 2s-8.756 0-10.945.595c-.6.172-1.143.502-1.577.957a3.613 3.613 0 0 0-.892 1.63A38.12 38.12 0 0 0 1 12.026a38.12 38.12 0 0 0 .586 6.895c.166.595.481 1.136.914 1.571.432.435.968.75 1.555.913C6.244 22 14.999 22 14.999 22s8.756 0 10.945-.595a3.527 3.527 0 0 0 1.577-.957 3.613 3.613 0 0 0 .892-1.63c.398-2.242.594-4.515.586-6.792a38.12 38.12 0 0 0-.586-6.895v0Z",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m12 16 8-4-8-4v8Z",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6e996ea1.svg";
export { ForwardRef as ReactComponent };